(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maker-profile"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-maker-profile]').forEach(async (profile) => {
    const requestedMaker = new URLSearchParams(window.location.search).get('maker') || profile.dataset.sourceMaker
    if (!requestedMaker) return

    try {
      let makerRoot = profile.getAttribute('data-root-url')
      if (makerRoot == null || makerRoot === '') {
        makerRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
      }
      makerRoot = makerRoot === '/' ? '' : makerRoot.replace(/\/$/, '')
      const response = await fetch(makerRoot + '/pages/rinleaf-maker-collective?view=maker-collective&maker_source=1', { credentials: 'same-origin' })
      if (!response.ok) return
      const sourceDocument = new DOMParser().parseFromString(await response.text(), 'text/html')
      const source = Array.from(sourceDocument.querySelectorAll('[data-maker-profile-source]')).find((item) => item.dataset.makerProfileSource === requestedMaker)
      if (!source) return
      const maker = JSON.parse(source.textContent)

      let portrait = profile.querySelector('.maker-profile__portrait')
      if (!portrait && maker.photo) {
        portrait = document.createElement('img')
        portrait.className = 'maker-profile__portrait'
        profile.querySelector('.maker-profile__identity-copy')?.before(portrait)
      }
      if (portrait && maker.photo) {
        portrait.src = maker.photo
        portrait.removeAttribute('srcset')
        portrait.removeAttribute('sizes')
        portrait.alt = maker.name || ''
      }

      const heading = profile.querySelector('[data-maker-heading]')
      if (heading && maker.name) heading.textContent = window.RinleafI18n.meet.replaceAll('__NAME__', maker.name)
      const country = profile.querySelector('[data-maker-country]')
      if (country) country.textContent = maker.country || ''
      const role = profile.querySelector('[data-maker-role]')
      if (role) role.textContent = maker.role || window.RinleafI18n.handmadeCreator
      const bio = profile.querySelector('[data-maker-bio]')
      const readMore = profile.querySelector('[data-maker-read-more]')
      if (bio) {
        if (maker.bio) bio.innerHTML = maker.bio
        else bio.replaceChildren()
        const updateReadMore = () => {
          if (!readMore) return
          const wasExpanded = readMore.getAttribute('aria-expanded') === 'true'
          bio.classList.remove('is-collapsed')
          const lineHeight = parseFloat(getComputedStyle(bio).lineHeight) || 24
          const isOverflowing = bio.scrollHeight > (lineHeight * 6) + 1
          readMore.hidden = !isOverflowing
          if (isOverflowing && !wasExpanded) bio.classList.add('is-collapsed')
        }
        readMore?.addEventListener('click', () => {
          const expanded = readMore.getAttribute('aria-expanded') === 'true'
          readMore.setAttribute('aria-expanded', String(!expanded))
          readMore.textContent = expanded ? window.RinleafI18n.readMore : window.RinleafI18n.readLess
          bio.classList.toggle('is-collapsed', expanded)
        })
        requestAnimationFrame(updateReadMore)
        window.addEventListener('resize', updateReadMore, { passive: true })
      }
      const contact = profile.querySelector('[data-maker-contact]')
      const contactLabel = profile.querySelector('[data-maker-contact-label]')
      if (contact) {
        if (maker.contact) {
          contact.href = maker.contact
          const contactUrl = maker.contact.toLowerCase()
          contact.dataset.contactType = contactUrl.startsWith('mailto:') ? 'email' : contactUrl.includes('instagram.com') ? 'instagram' : contactUrl.includes('facebook.com') ? 'facebook' : 'link'
          contact.hidden = false
          contact.classList.remove('maker-profile__contact--disabled')
          contact.removeAttribute('aria-disabled')
          if (contactLabel) contactLabel.textContent = maker.contact_label || (contact.dataset.contactType === 'email' ? maker.contact.replace(/^mailto:/i, '') : window.RinleafI18n.contactMaker)
        } else {
          contact.hidden = true
          contact.removeAttribute('href')
          contact.classList.add('maker-profile__contact--disabled')
          contact.setAttribute('aria-disabled', 'true')
        }
      }
      const creationsHeading = profile.querySelector('[data-maker-creations-heading]')
      if (creationsHeading && maker.name) creationsHeading.textContent = window.RinleafI18n.creations.replaceAll('__NAME__', maker.name)

      const pieces = profile.querySelector('[data-maker-pieces]')
      if (!pieces || !Array.isArray(maker.pieces)) return
      pieces.replaceChildren()
      const lightbox = profile.querySelector('[data-maker-lightbox]')
      const lightboxImage = lightbox?.querySelector('[data-maker-lightbox-image]')
      const closeLightbox = () => lightbox?.close()
      lightbox?.querySelector('[data-maker-lightbox-close]')?.addEventListener('click', closeLightbox)
      lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox() })
      maker.pieces.forEach((piece) => {
        const article = document.createElement('article')
        article.className = 'maker-profile__piece'
        const content = document.createElement('div')
        content.className = 'maker-profile__piece-content'
        const imageWrap = document.createElement('div')
        imageWrap.className = 'maker-profile__image-wrap'
        if (piece.image) {
          const image = document.createElement('img')
          image.src = piece.image
          image.alt = piece.title || ''
          image.loading = 'lazy'
          image.width = 1000
          image.height = 1000
          imageWrap.append(image)
          const imageButton = document.createElement('button')
          imageButton.type = 'button'
          imageButton.className = 'maker-profile__image-button'
          imageButton.setAttribute('aria-label', window.RinleafI18n.viewPieceImage.replaceAll('__TITLE__', piece.title || window.RinleafI18n.makerPiece))
          imageButton.append(imageWrap)
          imageButton.addEventListener('click', () => {
            if (!lightbox || !lightboxImage) return
            lightboxImage.src = piece.image
            lightboxImage.alt = piece.title || ''
            lightbox.showModal()
          })
          content.append(imageButton)
        } else {
          content.append(imageWrap)
        }
        const title = document.createElement('h3')
        title.textContent = piece.title || ''
        const price = document.createElement('p')
        price.textContent = piece.price || ''
        if (piece.link) {
          const detailsLink = document.createElement('a')
          detailsLink.href = piece.link
          detailsLink.className = 'maker-profile__piece-link'
          detailsLink.append(title, price)
          content.append(detailsLink)
        } else {
          content.append(title, price)
        }
        article.append(content)
        pieces.append(article)
      })
    } catch (error) {
      console.warn('Maker profile sync failed', error)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maker-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-maker-showcase]').forEach((section) => {
    const slider = section.querySelector('[data-ms-slider]')
    let suppressClick = false
    let pointerDown = false
    let dragging = false
    let startX = 0
    let startY = 0
    let startScrollLeft = 0
    let frameId = 0
    let nextScrollLeft = 0
    slider?.querySelectorAll('img').forEach((image) => { image.draggable = false })
    slider?.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.pointerType === 'pen' || event.button !== 0) return
      pointerDown = true
      dragging = false
      startX = event.clientX
      startY = event.clientY
      startScrollLeft = slider.scrollLeft
      nextScrollLeft = slider.scrollLeft
    })
    slider?.addEventListener('pointermove', (event) => {
      if (!pointerDown) return
      const deltaX = event.clientX - startX
      const deltaY = event.clientY - startY
      if (!dragging) {
        if (Math.abs(deltaX) < 8) return
        if (Math.abs(deltaX) <= Math.abs(deltaY)) { pointerDown = false; return }
        dragging = true
        suppressClick = true
        slider.classList.add('is-dragging')
        slider.setPointerCapture?.(event.pointerId)
      }
      event.preventDefault()
      nextScrollLeft = startScrollLeft - deltaX
      if (!frameId) frameId = requestAnimationFrame(() => { frameId = 0; slider.scrollLeft = nextScrollLeft })
    })
    const endDrag = (event) => {
      if (!pointerDown && !dragging) return
      pointerDown = false
      if (!dragging) return
      dragging = false
      slider.classList.remove('is-dragging')
      if (frameId) { cancelAnimationFrame(frameId); frameId = 0; slider.scrollLeft = nextScrollLeft }
      if (event && slider.releasePointerCapture) { try { slider.releasePointerCapture(event.pointerId) } catch (error) {} }
      if (event?.type === 'pointercancel' || event?.type === 'pointerleave') window.setTimeout(() => { suppressClick = false }, 0)
    }
    slider?.addEventListener('pointerup', endDrag)
    slider?.addEventListener('pointercancel', endDrag)
    slider?.addEventListener('pointerleave', endDrag)
    section.querySelectorAll('[data-ms-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; return }
      document.getElementById(trigger.dataset.msOpen)?.showModal()
    }))
    section.querySelectorAll('.ms-modal').forEach((modal) => {
      modal.querySelector('[data-ms-close]')?.addEventListener('click', () => modal.close())
      modal.addEventListener('click', (event) => { if (event.target === modal) modal.close() })
      modal.querySelectorAll('[data-ms-image]').forEach((thumb) => thumb.addEventListener('click', () => {
        const main = modal.querySelector('[data-ms-main]')
        if (main) {
          main.removeAttribute('srcset')
          main.removeAttribute('sizes')
          main.removeAttribute('data-srcset')
          main.removeAttribute('data-sizes')
          main.src = thumb.dataset.msImage
        }
        modal.querySelectorAll('[data-ms-image]').forEach((item) => item.classList.toggle('is-active', item === thumb))
      }))
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rinleaf-maker-collective"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rm-home]').forEach((section) => {
    const profiles = Array.from(section.querySelectorAll('[data-rm-profile]'))
    const selectMaker = (index) => profiles.forEach((profile, profileIndex) => { profile.hidden = profileIndex !== index; profile.classList.toggle('is-active', profileIndex === index) })
    section.querySelectorAll('[data-rm-maker]').forEach((button) => button.addEventListener('click', () => selectMaker(Number(button.dataset.rmMaker))))
    selectMaker(0)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fitHomeHero = (root = document) => {
      root.querySelectorAll('[data-rinleaf-home-hero]').forEach((hero) => {
        const setHeight = () => {
          const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight
          const top = Math.max(0, hero.getBoundingClientRect().top)
          const availableHeight = Math.max(240, viewportHeight - top)
          const imageRatioHeight = hero.clientWidth * (window.matchMedia('(max-width: 767px)').matches ? 1.25 : 7 / 16)
          hero.style.setProperty('--rinleaf-hero-height', Math.floor(Math.min(imageRatioHeight, availableHeight)) + 'px')
        }
        if (hero.dataset.rinleafHeroBound !== 'true') {
          hero.dataset.rinleafHeroBound = 'true'
          window.addEventListener('resize', setHeight, { passive: true })
          if (window.visualViewport) window.visualViewport.addEventListener('resize', setHeight, { passive: true })
        }
        setHeight()
        requestAnimationFrame(setHeight)
        setTimeout(setHeight, 350)
      })
    }
    fitHomeHero()
    document.addEventListener('shopify:section:load', (event) => fitHomeHero(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!window.rinleafReviewModalReady) {
    window.rinleafReviewModalReady = true;
    let activeTrigger = null;
    let restoreFocusAfterClose = false;
    let activeImageTrigger = null;
    let restoreImageFocusAfterClose = false;
    let pointerStart = null;

    const showLightboxImage = (lightbox, index) => {
      const images = [...lightbox.closest('[data-review-modal]').querySelectorAll('[data-review-image]')];
      if (!images.length) return;
      const safeIndex = (index + images.length) % images.length;
      const source = images[safeIndex];
      const preview = source.querySelector('img');
      const largeImage = lightbox.querySelector('[data-review-lightbox-image]');
      lightbox.dataset.imageIndex = safeIndex;
      largeImage.src = source.dataset.fullImage || preview.currentSrc || preview.src;
      largeImage.alt = preview.alt || '';
      lightbox.querySelectorAll('[data-review-image-prev], [data-review-image-next]').forEach((button) => {
        button.hidden = images.length < 2;
      });
    };

    const openReviewImage = (trigger, viaKeyboard = false) => {
      const modal = trigger.closest('[data-review-modal]');
      const lightbox = modal?.querySelector('[data-review-lightbox]');
      if (!lightbox) return;
      const images = [...modal.querySelectorAll('[data-review-image]')];
      activeImageTrigger = trigger;
      restoreImageFocusAfterClose = viaKeyboard;
      showLightboxImage(lightbox, images.indexOf(trigger));
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => lightbox.focus({ preventScroll: true }));
    };

    const closeReviewImage = (lightbox) => {
      const trigger = activeImageTrigger;
      const shouldRestoreFocus = restoreImageFocusAfterClose;
      if (document.activeElement && lightbox.contains(document.activeElement)) document.activeElement.blur();
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      activeImageTrigger = null;
      restoreImageFocusAfterClose = false;
      requestAnimationFrame(() => {
        if (shouldRestoreFocus) trigger?.focus({ preventScroll: true });
        else trigger?.blur();
      });
    };

    const openReview = (trigger, viaKeyboard = false) => {
      const modal = document.getElementById(trigger.dataset.reviewOpen);
      if (!modal) return;
      activeTrigger = trigger;
      restoreFocusAfterClose = viaKeyboard;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');

      if (!viaKeyboard) {
        requestAnimationFrame(() => modal.focus({ preventScroll: true }));
      }
    };

    const closeReview = (modal) => {
      const trigger = activeTrigger;
      const shouldRestoreFocus = restoreFocusAfterClose;
      if (document.activeElement && modal.contains(document.activeElement)) document.activeElement.blur();
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      activeTrigger = null;
      restoreFocusAfterClose = false;

      requestAnimationFrame(() => {
        if (shouldRestoreFocus) trigger?.focus({ preventScroll: true });
        else trigger?.blur();
      });
    };

    document.addEventListener('pointerdown', (event) => {
      const trigger = event.target.closest('[data-review-open]');
      pointerStart = trigger ? { trigger, x: event.clientX, y: event.clientY, moved: false } : null;
    });

    document.addEventListener('pointermove', (event) => {
      if (!pointerStart) return;
      if (Math.abs(event.clientX - pointerStart.x) > 8 || Math.abs(event.clientY - pointerStart.y) > 8) pointerStart.moved = true;
    });

    document.addEventListener('click', (event) => {
      const imageClose = event.target.closest('[data-review-image-close]');
      if (imageClose) {
        closeReviewImage(imageClose.closest('[data-review-lightbox]'));
        return;
      }

      const lightbox = event.target.closest('[data-review-lightbox]');
      if (lightbox && event.target === lightbox) {
        closeReviewImage(lightbox);
        return;
      }

      const imagePrevious = event.target.closest('[data-review-image-prev]');
      const imageNext = event.target.closest('[data-review-image-next]');
      if (imagePrevious || imageNext) {
        const viewer = (imagePrevious || imageNext).closest('[data-review-lightbox]');
        const currentIndex = Number(viewer.dataset.imageIndex || 0);
        showLightboxImage(viewer, currentIndex + (imageNext ? 1 : -1));
        return;
      }

      const reviewImage = event.target.closest('[data-review-image]');
      if (reviewImage) {
        openReviewImage(reviewImage, event.detail === 0);
        return;
      }

      const closeButton = event.target.closest('[data-review-close]');
      if (closeButton) {
        closeReview(closeButton.closest('[data-review-modal]'));
        return;
      }

      const modal = event.target.closest('[data-review-modal]');
      if (modal && event.target === modal) {
        closeReview(modal);
        return;
      }

      const trigger = event.target.closest('[data-review-open]');
      if (!trigger) return;
      if (pointerStart?.trigger === trigger && pointerStart.moved) {
        pointerStart = null;
        return;
      }
      openReview(trigger, false);
      pointerStart = null;
    });

    document.addEventListener('keydown', (event) => {
      const lightbox = document.querySelector('[data-review-lightbox]:not([hidden])');
      if (lightbox) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeReviewImage(lightbox);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const currentIndex = Number(lightbox.dataset.imageIndex || 0);
          showLightboxImage(lightbox, currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
        return;
      }

      const trigger = event.target.closest('[data-review-open]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        openReview(trigger, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
